<button
    *ngIf="!isMe && followedWalletAddressInfo && theme === 'light'"
    nz-button
    class="!w-full text-center leading-[1]"
    [ngClass]="{
        '!h-[48px]': size === 'large'
    }"
    [nzLoading]="updating"
    (click)="toggleFollowStatus()"
>
    <ng-container *ngIf="btnStatus === 'follow'">
        <span nz-icon nzType="antd:v2-follow" class="!text-2xl"></span>
        <span class="font-semibold text-sm">Follow</span>
    </ng-container>

    <span *ngIf="btnStatus === 'followed'" nz-icon nzType="antd:v2-followed" class="!text-2xl"></span>
</button>

<button
    *ngIf="!isMe && followedWalletAddressInfo && theme === 'dark'"
    nz-button
    class="text-center leading-[1] !bg-black !text-white !w-[112px]"
    [ngClass]="{
        '!h-[48px]': size === 'large'
    }"
    [nzLoading]="updating"
    (click)="toggleFollowStatus()"
>
    <ng-container *ngIf="btnStatus === 'follow'">
        <span nz-icon nzType="antd:v2-follow-gradient" class="!text-2xl"></span>
        <span class="font-semibold text-sm colorful-text">Follow</span>
    </ng-container>

    <span *ngIf="btnStatus === 'followed'" nz-icon nzType="antd:v2-followed" class="!text-2xl"></span>
</button>
